import type { Unit } from "generated/prisma/browser";

export const pad2 = (n: number) => String(n).padStart(2, "0");

export const firstName = (name?: string | null) =>
  (name ?? "").trim().split(/\s+/)[0] ?? "";

export const initials = (name?: string | null) => {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  const first = parts[0]!.charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1]!.charAt(0) : "";
  return (first + last).toUpperCase();
};

/** "PEDIDO 014" — o número é a posição do pedido na campanha. */
export const orderCode = (position: number) => String(position).padStart(3, "0");

const UNIT_LABEL: Record<Unit, string> = {
  G: "g",
  KG: "kg",
  L: "L",
  ML: "ml",
  UN: "un",
  GRANEL: "",
};

export const unitLabel = (unit: Unit | string) =>
  UNIT_LABEL[unit as Unit] ?? String(unit).toLowerCase();

/** 32.1 → "32,1"; inteiros ficam sem casas. */
export const formatQuantity = (n: number) =>
  new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 }).format(n);

export const WEEKDAYS = [
  "DOMINGO",
  "SEGUNDA",
  "TERÇA",
  "QUARTA",
  "QUINTA",
  "SEXTA",
  "SÁBADO",
];
export const MONTHS = [
  "JANEIRO",
  "FEVEREIRO",
  "MARÇO",
  "ABRIL",
  "MAIO",
  "JUNHO",
  "JULHO",
  "AGOSTO",
  "SETEMBRO",
  "OUTUBRO",
  "NOVEMBRO",
  "DEZEMBRO",
];

/** "QUINTA, 9 DE OUTUBRO" */
export const eyebrowDate = (d: { day(): number; date(): number; month(): number }) =>
  `${WEEKDAYS[d.day()]}, ${d.date()} DE ${MONTHS[d.month()]}`;
